import { UserStatsRecord } from '../interfaces';

export const formatUsersWithCount = ({ users, count }: UserStatsRecord, suffix: string): string | undefined =>
  users.length === 0
    ? undefined
    : users.map((userData) => `${userData.getDisplayNameWithEmail()} (${count} ${suffix})`).join(', ');
